export default "__VITE_ASSET__Cub9UDoQ__"